<template>
  <div :class="{ 'category-row': true, 'category-row--child': level > 0 }">
    <div class="category-row__expand">
      <span
        v-if="hasChildren"
        class="category-row__expand-btn"
        @click="toggleExpand"
      >
        <i :class="['fa', expanded ? 'fa-chevron-down' : 'fa-chevron-right']" />
      </span>
      <span v-else class="category-row__expand-placeholder" />
    </div>
    <div class="category-row__name">
      <div class="category-row__indent" :style="{ width: indentPx }"></div>
      <span class="category-row__name-text">{{ category.name }}</span>
    </div>
    <div class="category-row__count">{{ category.products_count || 0 }}</div>
    <div class="category-row__title">{{ category.meta_title || "—" }}</div>
    <div class="category-row__photo">
      <div v-if="category.photo" class="category-img-wrap">
        <img class="category-img" :src="category.photo" alt="category" />
      </div>
      <span v-else>—</span>
    </div>
    <div class="category-row__description">
      {{ (category.meta_description || "—") | truncate(50) }}
    </div>
    <div class="category-row__hidden">
      {{ category.is_hidden ? "Скрыт" : "—" }}
    </div>
    <div class="category-row__actions">
      <va-button
        flat
        small
        color="gray"
        icon="fa fa-arrow-up"
        title="Выше"
        :disabled="!canMoveUp"
        @click="$emit('move-up', category)"
      />
      <va-button
        flat
        small
        color="gray"
        icon="fa fa-arrow-down"
        title="Ниже"
        :disabled="!canMoveDown"
        @click="$emit('move-down', category)"
      />
      <va-button
        flat
        small
        color="gray"
        icon="fa fa-plus"
        title="Добавить категорию"
        @click="$emit('add-child', category)"
      />
      <va-button
        flat
        small
        color="gray"
        icon="fa fa-pencil"
        @click="$emit('edit', category)"
      />
      <va-button
        v-if="allCategoriesCount !== 1"
        flat
        small
        color="gray"
        icon="fa fa-trash"
        @click="$emit('remove', category.slug)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryRow",
  filters: {
    truncate(value, size) {
      if (!value) return "";
      const str = value.toString();
      if (str.length <= size) return str;
      return str.substr(0, size) + "...";
    },
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    expandedIds: {
      type: Object,
      default: () => ({}),
    },
    allCategoriesCount: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    siblings: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasChildren() {
      const children = this.category.children;
      return Array.isArray(children) && children.length > 0;
    },
    expanded() {
      return Boolean(this.expandedIds[this.category.id]);
    },
    indentPx() {
      return `${this.level * 20}px`;
    },
    canMoveUp() {
      return this.index > 0;
    },
    canMoveDown() {
      return this.index < this.siblings.length - 1;
    },
  },
  methods: {
    toggleExpand() {
      this.$emit("toggle-expand", this.category.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.category-row {
  display: grid;
  grid-template-columns: 48px 1fr 70px 1fr 80px 1fr 70px 210px;
  gap: 0 16px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  min-height: 48px;

  &__expand {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  &__expand-btn {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    color: #6c757d;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: #495057;
    }
  }
  &__expand-placeholder {
    display: inline-block;
    width: 24px;
  }
  &__name {
    display: flex;
    align-items: center;
    font-weight: 500;
    padding: 0;
    min-width: 0;
  }
  &__indent {
    flex-shrink: 0;
    border-right: 3px solid rgb(0, 0, 0);
    height: 36px;
  }
  &__name-text {
    padding: 0 0.625rem;
    flex: 1;
    min-width: 0;
  }
  &__count {
    text-align: center;
  }
  &__photo {
    .category-img-wrap {
      max-width: 80px;
    }
  }
  &__actions {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-wrap: nowrap;
  }
}
.category-img {
  width: 60px;
  height: auto;
  max-height: 40px;
  object-fit: contain;
  display: block;
}
</style>
